import * as React from 'react';
import { connect } from 'react-redux'
import * as queryString from 'query-string';
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import Spinner from "../common/spinner";
import InfoModal from '../common/InfoModal';
import { translateText } from "../../helpers/data";
const OK_LABEL = 'OK, CONTINUE';
const BACK_TO_HOME = 'BACK TO HOME';

class Questionnaire extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tooltipOpen: false,
        }
        this.mammogramResponseData = {};
        this.currentPatientId = "";
        this.questions = {};
        this.editQue = this.editQue.bind(this);
        this.setInitialAnswerValue = this.setInitialAnswerValue.bind(this);
        this.listOfoptionsSelected = [];
        this.openModal = false;
        this.goToHome = this.goToHome.bind(this);
    }


    componentDidMount() {
        logUI("MBHWeb.UI.Questionnaire.ComponentDidMount", new Date(), Tools.getURLPath());
        this.currentPatientId = this.props.patientId;
    }

    // on "Back to Calender" click
    editQue(e) {
        if (e) { e.preventDefault(); }
        this.props.questionsLoaded(true);
        this.props.goBack(0);
        this.props.backToCalender(true);
    }

    /// to store question responses
    setInitialAnswerValue() {
        const { questionResponseData, mammogramQuestions, enableNewServiceSchedulingWorkflow, isFromDotCOM } = this.props;
        const selectedQue = mammogramQuestions && Object.keys(mammogramQuestions).length ? mammogramQuestions : {};
        let questionArray = [];
        if (Object.keys(selectedQue).length) {
            const question = selectedQue.questions;
            for (let count = 0; count < question.length; count++) {
                if (isFromDotCOM && enableNewServiceSchedulingWorkflow && questionResponseData && question[count].id in questionResponseData) {
                    questionArray.push({
                        questionID: question[count].id,
                        answerValue: questionResponseData[question[count].id]
                    })
                } else
                    questionArray.push({
                        questionID: question[count].id,
                        answerValue: null
                    })
            }
            this.listOfoptionsSelected = questionArray;
            const valuObj = {
                patientID: "",
                questionnaireID: selectedQue.questionnaireID,
                answerContainer: {
                    answers: questionArray
                },
            }
            this.mammogramResponseData = valuObj;
            if (isFromDotCOM && enableNewServiceSchedulingWorkflow) {
                const isAllQueAnswered = this.checkAnsValue();
                this.props.sendBack(isAllQueAnswered);
                if (isAllQueAnswered) {
                    this.mammogramResponseData.patientID = this.props.patientId;
                    this.props.sendDataToMammogramParent(this.mammogramResponseData, this.props.token);
                }
            }
        }

    }

    componentDidUpdate(prevProps, prevState) {
        const { isMammogram, location, byPassProxyAndInfo, goNext, goToNewStep, isNonProxyUser, reasonSubmitStepValue } = this.props;

        const params = location.search ? queryString.parse(location.search) : {};
        const { s } = params;

        if (prevProps !== this.props && byPassProxyAndInfo && typeof s !== 'undefined') {
            if (isNonProxyUser && s == 1 || !isNonProxyUser && s == 2) {
                if (isNonProxyUser && s == 1 && reasonSubmitStepValue)
                    goToNewStep(true, reasonSubmitStepValue);
            }
        }
        if (isMammogram) {
            this.setQuestions()
        }

        if (this.props.mammogramAnswersError) {
            this.mammogramResponseData = {}
        }

    }

    setQuestions = () => {
        const { mammogramQuestions, currentStep, isUserActivated, patientId, screenCount } = this.props;
        // if (currentStep > screenCount) {
        //     this.props.backToCalender(false);
        //     //this.mammogramResponseData = {};
        //     // this.props.sendBack(false);
        //     // this.props.questionsLoaded(false);
        // } else {
        const questions = !this.props.mammogramQuestionsError ? Object.keys(mammogramQuestions).length ? mammogramQuestions : {} : {};
        if (Object.keys(questions).length) {
            this.props.questionsLoaded(true);
        }
        if (isUserActivated) {
            this.mammogramResponseData = {};
            this.questions = {};
            if (this.currentPatientId !== patientId) {
                this.props.newUserSelected(false);
                if (!Object.keys(this.mammogramResponseData).length) this.setInitialAnswerValue();
                this.currentPatientId = patientId;
                this.questions = questions;
            } else {
                this.questions = {};
            }
        } else {
            if (!Object.keys(this.mammogramResponseData).length) this.setInitialAnswerValue();
            this.questions = questions;
        }
        // }
    }

    goToNextStep = () => {
        //if (goNext) goNext();
    }

    // to check all questions answered
    checkAnsValue = () => {
        let queResponse = this.mammogramResponseData && this.mammogramResponseData.answerContainer && this.mammogramResponseData.answerContainer.answers;
        for (let i = 0; i < queResponse.length; i++) {
            if (queResponse[i].answerValue === null) {
                return false;
            }

        }
        return true;

    }

    // on question answer selected
    onAnswerSelected = (questionnaireId, answer, questionId) => {
        this.handleAnswers(answer, questionId);
        let mammogramAnswerModel = {
            departmentID: "",
            patientID: "",
            questionnaireID: questionnaireId,
            answerContainer: {
                answers: [
                    {
                        questionID: questionId,
                        answerValue: answer
                    }
                ]
            }
        }
        this.props.getMammogramQuestionsResponse(mammogramAnswerModel, this.props.token);
        const isAllQueAnswered = this.checkAnsValue();
        this.props.sendBack(isAllQueAnswered);
        if (isAllQueAnswered) {
            this.mammogramResponseData.patientID = this.props.patientId;
            this.props.sendDataToMammogramParent(this.mammogramResponseData, this.props.token);
        }
    }

    // to store answers 
    handleAnswers = (answer, questionId) => {
        let resData = this.mammogramResponseData && this.mammogramResponseData.answerContainer && this.mammogramResponseData.answerContainer.answers;
        for (let i = 0; i < resData.length; i++) {
            if (resData[i].questionID === questionId) {
                resData[i].answerValue = answer;
            }

        }
        this.mammogramResponseData.answerContainer.answers = resData;
    }
    onGoNext() {
        // to call getArrival time api
        this.getArrivalTimeResponse();
    }

    getArrivalTimeResponse = () => {
        const { changedVisitTypeId, visit } = this.props;
        let arrivalTimeModel = null;
        arrivalTimeModel = {
            visitTypeId: changedVisitTypeId ? changedVisitTypeId : "",
            departmentId: visit && visit.department && visit.department.id ? `${visit.department.id}` : "",
        }
        this.props.getArrivalTimeSchedule(arrivalTimeModel, this.scheduleCallCompleted);
    }

    onAnswerChange = (answer, answerIndex) => {
        const newData = this.state.questions.map((item, index) => index === answerIndex ? { ...item, answer } : item)
        this.setState({ questions: newData });
    }

    toggleToolTip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    closeModal = () => {
        this.props.resetMammogramQuestionCurrentResponse();
        this.openModal = false;
    }

    navigateToHome = () => {
        this.closeModal();
        this.goToHome();
    }

    goToHome() {
        this.props.history.push({
            pathname: '/'
        });
    }

    render() {
        const { isMammogram, phoneNumber, currentStep, isLoadQuestionsCompleted, screenCount, t, enableNewMammogramJourneyChanges } = this.props;
        const stepHeading = enableNewMammogramJourneyChanges ? translateText(true, "Please answer the following questions", t) : translateText(true, "Please answer a few questions to prepare for your screening mammogram", t);

        if (isMammogram) {
            const patientMessage = this.props.mammogramAnswers?.patientMessage;
            this.openModal = patientMessage?.length ? true : false;
            const newLineMessage = patientMessage && patientMessage.length && patientMessage.split('<BR>');
            const questionsData = this.questions && Object.keys(this.questions).length ? this.questions : {};
            const actionButton = this.props.mammogramAnswers?.actions;
            
            // if (Object.keys(questionsData).length && isLoadQuestionsCompleted && !this.props.mammogramQuestionsError) 
            if (Object.keys(questionsData).length && !this.props.mammogramQuestionsError) {
                return (
                    <>
                        <div className="questionnaire-container" style={this.props.style}>
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="step-heading">{stepHeading}</h1>
                                </div>
                            </div>
                            {questionsData && Object.keys(questionsData).length && questionsData.questions ? questionsData.questions.map((item, index) =>
                                <div className="row" key={item.prompt}>
                                    <div className="col-12">
                                        <p>
                                            {translateText(true, item.prompt, t)}
                                        </p>
                                    </div>
                                    <div className="col-12">
                                        <div className="question-button-container">
                                            <button className={`btn btn-primary ${this.listOfoptionsSelected && this.listOfoptionsSelected.length && this.listOfoptionsSelected[index].answerValue === item.responseList[0].value ? translateText(true, "selected", t) : ""}`} onClick={() => this.onAnswerSelected(questionsData.questionnaireID, item.responseList[0].value, item.id)}>{translateText(true, item.responseList[0].text, t)}</button>
                                            <button className={`btn btn-primary ${this.listOfoptionsSelected && this.listOfoptionsSelected.length && this.listOfoptionsSelected[index].answerValue === item.responseList[1].value ? translateText(true, "selected", t) : ""}`} onClick={() => this.onAnswerSelected(questionsData.questionnaireID, item.responseList[1].value, item.id)}>{translateText(true, item.responseList[1].text, t)}</button>
                                        </div>
                                    </div>
                                </div>
                            ) :
                                <div></div>}
                        </div>

                        {patientMessage && patientMessage.length && actionButton && actionButton.length ? <div>
                            <InfoModal
                                alignText="center"
                                className="question-model"
                                hideBorder
                                isOpen={this.openModal}
                                isMammogram={true}
                                t={t}
                                modalBody={
                                    newLineMessage && newLineMessage.length && newLineMessage.map(msg =>
                                        !msg.includes('<PHONE>') ?
                                            <><p className="popup-msg">{translateText(true, msg.trim(), t)}</p></>
                                            : <p className="popup-msg">{translateText(true, msg.split('<PHONE>')[0], t)}<a href={phoneNumber ? "tel:" + (phoneNumber) : "#"} className="phone-link">{phoneNumber}</a>{translateText(true, msg.split('<PHONE>')[1].trim(),t)}</p>
                                    )
                                }
                                modalFooter={<>
                                    <div className="question-button-container-footer">
                                        {actionButton[0] && actionButton[0] === OK_LABEL.replace(' ', '') ? <button className={`btn btn-primary btn-question`} onClick={() => this.closeModal()}>{translateText(true, OK_LABEL, t)}</button> : actionButton[0] && actionButton[0] === BACK_TO_HOME && <button onClick={() => this.navigateToHome()} className={`btn btn-primary`}>{translateText(true, actionButton[0], t)}</button>}
                                        {actionButton[1] && <button className={`btn btn-primary btn-question`} onClick={(e) => { this.editQue(e); this.closeModal() }}>{translateText(true, actionButton[1], t)}</button>}
                                    </div>
                                </>}
                            />
                        </div> : <div></div>}
                    </>
                );
            } else if ((isLoadQuestionsCompleted && currentStep === screenCount && !this.props.mammogramQuestionsError) || ((currentStep === screenCount) && !this.props.mammogramQuestionsError)) {
                return (
                    <>
                        <div className="questionnaire-container" style={this.props.style}>
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="step-heading">{stepHeading}</h1>
                                </div>
                            </div>
                        </div>
                        <Spinner />
                    </>
                );
            } else {
                return (
                    <></>
                )
            }

        } else {
            return (
                <div className="questionnaire-container" style={this.props.style}>
                    <div className="row">
                        <div className="col-12">
                            <h1 className="step-heading">{stepHeading}</h1>
                        </div>
                    </div>
                </div>
            )
        }


    }
}

const mapStateToProps = (state) => {
    return {
        byPassProxyAndInfo: state.openScheduling.byPassProxyAndInfo,
        mammogramAnswers: state.openScheduling.mammogramAnswers,
        response: state.openScheduling.response,
        mammogramAnswersError: state.openScheduling.mammogramAnswersError
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBypassProxyAndInfo: payload => dispatch({ type: types.UPDATE_BYPASS_PROXY_AND_INFO, payload }),
        getMammogramQuestionsResponse: (QuestionResponseSearchModel, token) => dispatch({ type: types.OPEN_SCHEDULE_MAMMOGRAM_ANSWERS, searchModel: QuestionResponseSearchModel, token }),
        getArrivalTimeSchedule: (arrivalTimeModel, callback) => {
            dispatch({ type: types.OPEN_SCHEDULE_ARRIVAL_TIME, searchModel: arrivalTimeModel, callback });
        },
        resetMammogramQuestionCurrentResponse: () => dispatch({ type: types.OPEN_SCHEDULE_RESET_MAMMOGRAM_QUESTION_CURRENT_RESPONSE }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Questionnaire);